import { render } from "./ServicioDeDeudaComponent.vue?vue&type=template&id=9263a0a2&scoped=true"
import script from "./ServicioDeDeudaComponent.vue?vue&type=script&lang=js"
export * from "./ServicioDeDeudaComponent.vue?vue&type=script&lang=js"

import "./ServicioDeDeudaComponent.vue?vue&type=style&index=0&id=9263a0a2&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9263a0a2"]])

export default __exports__